/**
 * Auto-registration module for client columns.
 * Import this file to register all client column definitions.
 */
import { registerNewsClientColumn } from './news';
import { registerNotesClientColumn } from './notes';
import { registerOrderSideClientColumn } from './orderSide';

// Register all client columns
registerNewsClientColumn();
registerNotesClientColumn();
registerOrderSideClientColumn();

// Export a marker to indicate registration is complete
export const CLIENT_COLUMNS_REGISTERED = true;
